import {
  AxiosDynamicString,
  AxiosRequestConfig,
  isSameOriginRequest,
  getDynamicString
} from "@ksxz/axios";

export function allowSetCustomHeaders(
  config: AxiosRequestConfig,
  origin?: AxiosDynamicString
) {
  const { url, baseURL } = config;
  return isSameOriginRequest(url, baseURL, getDynamicString(config, origin));
}
